module.exports = __webpack_public_path__ + "img/5.6f681a40.jpg";